import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Button, Text, InputGroup, Input, InputRightElement, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import Pagination from 'src/components/shared/pagination/Pagination';
import Breadcrumbs from 'src/components/shared/breadcrumbs/Breadcrumbs';
import BlogsTable from './Table';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';

import { getBlogs } from 'src/store/blogs/blogsSlice';

import { Wrapper } from './Styles';

import theme from '../../global/theme';

const Blogs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const blogs = useSelector(state => state.blogs);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const [showCreateBlog, setShowCreateBlog] = useState(false);
  const [showUpdateBlog, setShowUpdateBlog] = useState(false);
  const [showDeleteBlog, setShowDeleteBlog] = useState(false);

  useEffect(() => {
    dispatch(getBlogs({ page, query }));
  }, [dispatch, page, query]);


  return (
    <Wrapper>
      <Breadcrumbs
        currentPage={t('pages.blogs.blogs')}
        pages={[{ name: `${t('pages.dashboard.dashboard')}`, path: '/' }]}
      />

      {blogs.error && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          <Text>{blogs.error}</Text>
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" textTransform="uppercase"
            fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white" _hover={{ bg: 'red.600' }}
            onClick={() => setShowCreateBlog(true)}
          >
            {t('general.create')} +
          </Button>
        </Flex>

        <Flex marginBottom={8} justifyContent="flex-end">
          <InputGroup width="auto">
            <Input auth="auto" type="text" placeholder={t('general.search')}
              bg={theme.light} boxShadow={theme.shadow} color={theme.dark} border="none"
              onChange={(e) => setQuery(e.currentTarget.value)}
            />
            <InputRightElement color={theme.light} children={<FiIcons.FiSearch />} />
          </InputGroup>
        </Flex>
      </SimpleGrid>

      {blogs.itemsCount > 0 ? (
        <BlogsTable
          data={blogs.data}
          page={page}
          handleUpdate={(el) => setShowUpdateBlog(el)}
          handleDelete={(el) => setShowDeleteBlog(el)}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200} alignItems="center"
          justifyContent="center" borderRadius={16}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {t('pages.blogs.no_blogs')}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={blogs.itemsCount ?? 0}
          onChange={(page) => setPage(page)}
        />
      </Flex>

      {showCreateBlog && <CreateModal onClose={() => setShowCreateBlog(false)} />}
      {showUpdateBlog && <UpdateModal data={showUpdateBlog} onClose={() => setShowUpdateBlog(false)} />}
      {showDeleteBlog && <DeleteModal data={showDeleteBlog} onClose={() => setShowDeleteBlog(false)} />}
    </Wrapper>
  )
}

export default Blogs